import { CompensationCodes } from './CompensationCodes';
import { CouponsAndVouchersSheet } from './CouponsAndVouchersSheet';
import { Vouchers } from './Vouchers';
import { BonusPointsSheet } from './BonusPointsSheet';
import { BonusPointsSheetTracking } from './BonusPointsSheetTracking';
import { EmployeeBonusPoints } from './EmployeeBonusPoints';
import { BonusPoints } from '../basket-checkout-common/BonusPoints';
import { Snackbar } from '../basket-checkout-common/Snackbar';
import { PartialReloader } from '../basket-checkout-common/PartialReloader';
import { Reloader } from '../basket-checkout-common/Reloader';
import { Tracking } from '../shared/Tracking';
import { SettingsService } from '../shared/SettingsService';
import { BasketChangedEmitter } from '../basket-checkout-common/BasketChangedEmitter';

const snackbar = new Snackbar();
const settings = new SettingsService();
const basketChangedEmitter = new BasketChangedEmitter(settings);

const partialReloader = new PartialReloader(
    {
        partialUrl: '/order/checkoutV2Part',
        containerSelector: '.order_js_checkout_v2',
        changedEvent: 'basket.changed'
    },
    snackbar,
    basketChangedEmitter
);

const isCheckoutV2 = !!document.querySelector('#checkoutV2');

const reloader = new Reloader(partialReloader, isCheckoutV2);
const bonusPoints = new BonusPoints(reloader);
const tracking = new Tracking();

new CouponsAndVouchersSheet().initialize();

new Vouchers(reloader, tracking).initialize();

new CompensationCodes(reloader, tracking, message => snackbar.showMessage(message)).initialize();

const bonusPointsSheetTracking = new BonusPointsSheetTracking(tracking);
new BonusPointsSheet(bonusPointsSheetTracking, bonusPoints).initialize();

new EmployeeBonusPoints(bonusPoints, tracking);
